import { useCallback, type ReactElement } from 'react'
import { useToastError } from '@hooks'
import { useTranslation, useUpdateProgram } from '@front/model'
import { Page, type PageHeadingProps, TAlert, TButton } from '@components'
import { useProgramContext } from './context'

export const ProgramHeading = (props: PageHeadingProps): ReactElement => {
  const { t } = useTranslation()
  const { program, isFetching, refetch } = useProgramContext()
  const { update, isUpdating, error } = useUpdateProgram()
  useToastError(error)

  const handleRestore = useCallback(() => {
    update({
      programId: program.programId,
      isDeleted: false,
    })
  }, [update, program])

  if (!program.isDeleted) return <Page.Heading isFetching={isFetching} refetch={refetch} {...props} />
  return (
    <>
      <Page.Heading isFetching={isFetching} refetch={refetch} {...props} />
      <Page.FunctionBar>
        <TAlert className='w-full' title={t('This program is in Trash')}>
          <TButton loading={isUpdating} variant='secondary' onClick={handleRestore}>
            {t('Restore')}
          </TButton>
        </TAlert>
      </Page.FunctionBar>
    </>
  )
}
